import React from 'react';

import { Typography } from 'app/components/domain/typography';
import { i18n } from 'app/i18n';
import { SmallContainer } from 'app/components/common/container';

import styles from './choose-page.module.scss';

interface Props {
    title: string;
    subtitle: string;
    content: React.ReactNode;
}

export const ChoosePage: React.FC<Props> = (props: Props) => {
    const { title, subtitle, content } = props;

    return (
        <SmallContainer additionalStyles={styles.choosePageContainer}>
            <Typography variant="title" className={styles.heading}>
                {title}
            </Typography>
            <Typography variant="subtitle2" className={styles.subtitle}>
                {subtitle}
            </Typography>
            <Typography variant="body1" className={styles.select}>
                {i18n.components.choosePage.select}
            </Typography>
            {content}
        </SmallContainer>
    );
};
